import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import {
  useGetLeadStatusQuery,
  useUpdateLeadStatusMutation,
} from "@/redux/rtk/features/leadStatus/leadStatusApi";

import { Button, ColorPicker, Form, Input } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function UpdateLeadStatus({ data, onClose }) {
  const { t } = useTranslation();
  const { id } = data;
  const [form] = Form.useForm();
  const [colorCode, setColorCode] = useState("#1677FF");

  const { data: leadStatus, isLoading: leadStatusLoading } =
    useGetLeadStatusQuery({ id });

  const [updateLeadStatus, { isLoading }] = useUpdateLeadStatusMutation();

  const onFinish = async (values) => {
    const formData = {
      name: values.name,
      colorCode: colorCode,
    };

    const resp = await updateLeadStatus({ id, values: formData });
    if (resp.data) {
      form.resetFields();
      onClose();
    }
  };

  useEffect(() => {
    if (leadStatus) {
      form.setFieldsValue({
        ...leadStatus,
      });
      setColorCode(leadStatus.color || leadStatus.colorCode || "#1677FF");
    }
  }, [form, leadStatus]);

  return (
    <div className="flex justify-center mt-5">
      <UserPrivateComponent permission="update-leadStatus" type="update" comment={t("common.permissionError")}>
        <Form
          className="w-full"
          onFinish={onFinish}
          colon={false}
          layout="vertical"
          form={form}>
          <div className="w-full px-10">
            <Form.Item
              label={t("leadStatus.name")}
              name="name"
              rules={[
                { required: true, message: t("leadStatus.nameRequired") },
              ]}>
              <Input placeholder={t("leadStatus.name")} />
            </Form.Item>

            <Form.Item label={t("leadStatus.colorCode")} required>
              <ColorPicker
                showText
                format="hex"
                value={colorCode}
                onChange={(code) => {
                  setColorCode(code.toHexString());
                }}
                presets={[
                  {
                    colors: [
                      "#000000",
                      "#F5222D",
                      "#FA8C16",
                      "#FADB14",
                      "#8BBB11",
                      "#52C41A",
                      "#13A8A8",
                      "#1677FF",
                      "#2F54EB",
                      "#722ED1",
                      "#EB2F96",
                    ],
                  },
                ]}
              />
            </Form.Item>
          </div>

          <Form.Item label="" className="px-10">
            <div className="flex items-center gap-2">
              <Button
                size={"large"}
                htmlType="submit"
                type="primary"
                loading={isLoading}>
                {t("common.save")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
